import axios from './customAxios';

const saludProvider = {
  guardarFicha: async (ficha) => {
    return await axios.post('/ficha/guardarficha', ficha);
  },
  obtenerFichasPaginado: async (paginacion) => {
    return await axios.post('/ficha/obtenerfichas', paginacion);
  },
  obtenerFichaPorId: async (id) => {
    return await axios.get('/ficha/ObtenerFicha/' + id);
  }
};

export default saludProvider;
